module.exports = __webpack_public_path__ + "img/img004.51f0e522.png";